import { useEffect } from 'react';
import type { ApplyFramePositionT } from '../../types';
export function useSetPositionOnInitialRender(applyFramePosition: ApplyFramePositionT) {
  useEffect(() => {
    applyFramePosition(0);
  }, [applyFramePosition]);
}